'use client';

import { Toggle } from '@base-ui/react/toggle';
import clsx from 'clsx';
import type { ReactNode } from 'react';

import { DataTestIds } from '@repo/frontend-shared';

import '@repo/sds/components/SDSToggleButton/SDSToggleButton.scss';

type SDSToggleButtonSize = 'small' | 'medium' | 'large';

export interface SDSToggleButtonProps {
  value: string;
  pressed?: boolean;
  defaultPressed?: boolean;
  isDisabled?: boolean;
  size?: SDSToggleButtonSize;
  children: ReactNode;
  className?: string;
  onPressedChange?: (pressed: boolean) => void;
  ariaLabel?: string;
  ariaLabelledBy?: string;
  ariaDescribedBy?: string;
  dataTestId?: string;
}

export function SDSToggleButton({
  value,
  pressed,
  defaultPressed = false,
  isDisabled = false,
  size = 'medium',
  children,
  className,
  onPressedChange,
  ariaLabel,
  ariaLabelledBy,
  ariaDescribedBy,
  dataTestId,
}: SDSToggleButtonProps) {
  const toggleClass = clsx(
    'SDSToggleButton',
    `SDSToggleButton--${size}`,
    {
      'SDSToggleButton--pressed': pressed,
      'SDSToggleButton--disabled': isDisabled,
    },
    className,
  );

  return (
    <Toggle
      className={toggleClass}
      value={value}
      pressed={pressed}
      defaultPressed={defaultPressed}
      disabled={isDisabled}
      onPressedChange={onPressedChange}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledBy}
      aria-describedby={ariaDescribedBy}
      data-testid={dataTestId || DataTestIds.SDS.SDS_TOGGLE_BUTTON}
    >
      {children}
    </Toggle>
  );
}
